var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "member-body" }, [
    _c("div", { staticClass: "member-content" }, [
      _c(
        "div",
        { staticClass: "member-products-body" },
        _vm._l(_vm.productsArr, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "products-item",
              class: {
                "products-item-selected": _vm.selectedProductIndex == index
              },
              on: {
                click: function($event) {
                  return _vm.changeSelectedPriduct(index)
                }
              }
            },
            [
              _c("div", { staticClass: "item-content" }, [
                _c("div", { staticClass: "title" }, [
                  _vm._v("\n            " + _vm._s(item.title) + "\n          ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "price" }, [
                  _vm._v("\n            ¥"),
                  _c("label", [_vm._v(_vm._s(item.sell_price))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "show-price" }, [
                  _vm._v("\n            ¥"),
                  _c("label", [_vm._v(_vm._s(item.show_price))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "unit-price" }, [
                _vm._v("\n          " + _vm._s(item.unit_price) + "\n        ")
              ]),
              _vm._v(" "),
              item.label_id != 0
                ? _c("div", { staticClass: "label" }, [
                    _vm._v("\n          " + _vm._s(item.label) + "\n        ")
                  ])
                : _vm._e()
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "rights-body" }, [
        _c("div", { staticClass: "rights-title" }, [_vm._v("会员尊享权益")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "rights-option" },
          _vm._l(_vm.memberOptions, function(item, index) {
            return _c("div", { key: index, staticClass: "rights-item" }, [
              _c("div", { staticClass: "icon" }, [
                _c("img", { attrs: { src: item.icon, alt: "" } })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "title" }, [
                _vm._v("\n            " + _vm._s(item.title) + "\n          ")
              ])
            ])
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "rights-body" }, [
        _c("div", { staticClass: "rights-title" }, [
          _vm._v("会员尊享权益对比")
        ]),
        _vm._v(" "),
        _vm.powersMap != null
          ? _c("div", { staticClass: "contrast-body" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "contrast-item" }, [
                _c("div", { staticClass: "contrast-item-name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.powersMap.max_disk.name) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contrast-item-vip" },
                  [
                    _vm.convertVipPower(
                      _vm.powersMap.max_disk.vip_1.show_value,
                      _vm.powersMap.max_disk.vip_1.value
                    ) === ""
                      ? [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/ic_allow.png"),
                              alt: ""
                            }
                          })
                        ]
                      : [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.convertVipPower(
                                  _vm.powersMap.max_disk.vip_1.show_value,
                                  _vm.powersMap.max_disk.vip_1.value
                                )
                              ) +
                              "\n            "
                          )
                        ]
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contrast-item-contrast" },
                  [
                    _vm.convertVipPower(
                      _vm.powersMap.max_disk.vip_0.show_value,
                      _vm.powersMap.max_disk.vip_0.value
                    ) === ""
                      ? [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/ic_allow.png"),
                              alt: ""
                            }
                          })
                        ]
                      : [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.convertVipPower(
                                  _vm.powersMap.max_disk.vip_0.show_value,
                                  _vm.powersMap.max_disk.vip_0.value
                                )
                              ) +
                              "\n            "
                          )
                        ]
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "contrast-item contrast-item-true" }, [
                _c("div", { staticClass: "contrast-item-name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.powersMap.code_limit_days.name) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contrast-item-vip contrast-item-vip-true" },
                  [
                    _vm.convertVipPower(
                      _vm.powersMap.code_limit_days.vip_1.show_value,
                      _vm.powersMap.code_limit_days.vip_1.value
                    ) === ""
                      ? [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/ic_allow.png"),
                              alt: ""
                            }
                          })
                        ]
                      : [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.convertVipPower(
                                  _vm.powersMap.code_limit_days.vip_0
                                    .show_value,
                                  _vm.powersMap.code_limit_days.vip_0.value
                                )
                              ) +
                              "\n            "
                          )
                        ]
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contrast-item-contrast" },
                  [
                    _vm.convertVipPower(
                      _vm.powersMap.code_limit_days.vip_1.show_value,
                      _vm.powersMap.code_limit_days.vip_1.value
                    ) === ""
                      ? [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/ic_allow.png"),
                              alt: ""
                            }
                          })
                        ]
                      : [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.convertVipPower(
                                  _vm.powersMap.code_limit_days.vip_0
                                    .show_value,
                                  _vm.powersMap.code_limit_days.vip_0.value
                                )
                              ) +
                              "\n            "
                          )
                        ]
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "contrast-item" }, [
                _c("div", { staticClass: "contrast-item-name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.powersMap.max_task_upload.name) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contrast-item-vip" },
                  [
                    _vm.convertVipPower(
                      _vm.powersMap.max_task_upload.vip_1.show_value,
                      _vm.powersMap.max_task_upload.vip_1.value
                    ) === ""
                      ? [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/ic_allow.png"),
                              alt: ""
                            }
                          })
                        ]
                      : [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.convertVipPower(
                                  _vm.powersMap.max_task_upload.vip_0
                                    .show_value,
                                  _vm.powersMap.max_task_upload.vip_0.value
                                )
                              ) +
                              "\n            "
                          )
                        ]
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contrast-item-contrast" },
                  [
                    _vm.convertVipPower(
                      _vm.powersMap.max_task_upload.vip_1.show_value,
                      _vm.powersMap.max_task_upload.vip_1.value
                    ) === ""
                      ? [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/ic_allow.png"),
                              alt: ""
                            }
                          })
                        ]
                      : [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.convertVipPower(
                                  _vm.powersMap.max_task_upload.vip_0
                                    .show_value,
                                  _vm.powersMap.max_task_upload.vip_0.value
                                )
                              ) +
                              "\n            "
                          )
                        ]
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "contrast-item contrast-item-true" }, [
                _c("div", { staticClass: "contrast-item-name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.powersMap.bool_unzip.name) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contrast-item-vip contrast-item-vip-true" },
                  [
                    _vm.convertVipPower(
                      _vm.powersMap.bool_unzip.vip_1.show_value,
                      _vm.powersMap.bool_unzip.vip_1.value
                    ) === ""
                      ? [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/ic_allow.png"),
                              alt: ""
                            }
                          })
                        ]
                      : [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.convertVipPower(
                                  _vm.powersMap.bool_unzip.vip_0.show_value,
                                  _vm.powersMap.bool_unzip.vip_0.value
                                )
                              ) +
                              "\n            "
                          )
                        ]
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contrast-item-contrast" },
                  [
                    _vm.convertVipPower(
                      _vm.powersMap.bool_unzip.vip_1.show_value,
                      _vm.powersMap.bool_unzip.vip_1.value
                    ) === ""
                      ? [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/ic_allow.png"),
                              alt: ""
                            }
                          })
                        ]
                      : [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.convertVipPower(
                                  _vm.powersMap.bool_unzip.vip_0.show_value,
                                  _vm.powersMap.bool_unzip.vip_0.value
                                )
                              ) +
                              "\n            "
                          )
                        ]
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "contrast-item" }, [
                _c("div", { staticClass: "contrast-item-name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.powersMap.max_download_speed.name) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contrast-item-vip" },
                  [
                    _vm.convertVipPower(
                      _vm.powersMap.max_download_speed.vip_1.show_value,
                      _vm.powersMap.max_download_speed.vip_1.value
                    ) === ""
                      ? [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/ic_allow.png"),
                              alt: ""
                            }
                          })
                        ]
                      : [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.convertVipPower(
                                  _vm.powersMap.max_download_speed.vip_0
                                    .show_value,
                                  _vm.powersMap.max_download_speed.vip_0.value
                                )
                              ) +
                              "\n            "
                          )
                        ]
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contrast-item-contrast" },
                  [
                    _vm.convertVipPower(
                      _vm.powersMap.max_download_speed.vip_1.show_value,
                      _vm.powersMap.max_download_speed.vip_1.value
                    ) === ""
                      ? [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/ic_allow.png"),
                              alt: ""
                            }
                          })
                        ]
                      : [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.convertVipPower(
                                  _vm.powersMap.max_download_speed.vip_0
                                    .show_value,
                                  _vm.powersMap.max_download_speed.vip_0.value
                                )
                              ) +
                              "\n            "
                          )
                        ]
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "contrast-item contrast-item-true" }, [
                _c("div", { staticClass: "contrast-item-name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.powersMap.bool_play_online.name) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contrast-item-vip contrast-item-vip-true" },
                  [
                    _vm.convertVipPower(
                      _vm.powersMap.bool_play_online.vip_1.show_value,
                      _vm.powersMap.bool_play_online.vip_1.value
                    ) === ""
                      ? [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/ic_allow.png"),
                              alt: ""
                            }
                          })
                        ]
                      : [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.convertVipPower(
                                  _vm.powersMap.bool_play_online.vip_0
                                    .show_value,
                                  _vm.powersMap.bool_play_online.vip_0.value
                                )
                              ) +
                              "\n            "
                          )
                        ]
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contrast-item-contrast" },
                  [
                    _vm.convertVipPower(
                      _vm.powersMap.bool_play_online.vip_1.show_value,
                      _vm.powersMap.bool_play_online.vip_1.value
                    ) === ""
                      ? [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/ic_allow.png"),
                              alt: ""
                            }
                          })
                        ]
                      : [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.convertVipPower(
                                  _vm.powersMap.bool_play_online.vip_0
                                    .show_value,
                                  _vm.powersMap.bool_play_online.vip_0.value
                                )
                              ) +
                              "\n            "
                          )
                        ]
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "contrast-item" }, [
                _c("div", { staticClass: "contrast-item-name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.powersMap.max_upload_size.name) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contrast-item-vip" },
                  [
                    _vm.convertVipPower(
                      _vm.powersMap.max_upload_size.vip_1.show_value,
                      _vm.powersMap.max_upload_size.vip_1.value
                    ) === ""
                      ? [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/ic_allow.png"),
                              alt: ""
                            }
                          })
                        ]
                      : [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.convertVipPower(
                                  _vm.powersMap.max_upload_size.vip_0
                                    .show_value,
                                  _vm.powersMap.max_upload_size.vip_0.value
                                )
                              ) +
                              "\n            "
                          )
                        ]
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contrast-item-contrast" },
                  [
                    _vm.convertVipPower(
                      _vm.powersMap.max_upload_size.vip_1.show_value,
                      _vm.powersMap.max_upload_size.vip_1.value
                    ) === ""
                      ? [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/ic_allow.png"),
                              alt: ""
                            }
                          })
                        ]
                      : [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.convertVipPower(
                                  _vm.powersMap.max_upload_size.vip_0
                                    .show_value,
                                  _vm.powersMap.max_upload_size.vip_0.value
                                )
                              ) +
                              "\n            "
                          )
                        ]
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "contrast-item contrast-item-true" }, [
                _c("div", { staticClass: "contrast-item-name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.powersMap.recycle_expired_days.name) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contrast-item-vip contrast-item-vip-true" },
                  [
                    _vm.convertVipPower(
                      _vm.powersMap.recycle_expired_days.vip_1.show_value,
                      _vm.powersMap.recycle_expired_days.vip_1.value
                    ) === ""
                      ? [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/ic_allow.png"),
                              alt: ""
                            }
                          })
                        ]
                      : [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.convertVipPower(
                                  _vm.powersMap.recycle_expired_days.vip_0
                                    .show_value,
                                  _vm.powersMap.recycle_expired_days.vip_0.value
                                )
                              ) +
                              "\n            "
                          )
                        ]
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contrast-item-contrast" },
                  [
                    _vm.convertVipPower(
                      _vm.powersMap.recycle_expired_days.vip_1.show_value,
                      _vm.powersMap.recycle_expired_days.vip_1.value
                    ) === ""
                      ? [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/ic_allow.png"),
                              alt: ""
                            }
                          })
                        ]
                      : [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.convertVipPower(
                                  _vm.powersMap.recycle_expired_days.vip_0
                                    .show_value,
                                  _vm.powersMap.recycle_expired_days.vip_0.value
                                )
                              ) +
                              "\n            "
                          )
                        ]
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "contrast-item" }, [
                _c("div", { staticClass: "contrast-item-name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.powersMap.code_max_files.name) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contrast-item-vip" },
                  [
                    _vm.convertVipPower(
                      _vm.powersMap.code_max_files.vip_1.show_value,
                      _vm.powersMap.code_max_files.vip_1.value
                    ) === ""
                      ? [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/ic_allow.png"),
                              alt: ""
                            }
                          })
                        ]
                      : [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.convertVipPower(
                                  _vm.powersMap.code_max_files.vip_0.show_value,
                                  _vm.powersMap.code_max_files.vip_0.value
                                )
                              ) +
                              "\n            "
                          )
                        ]
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contrast-item-contrast" },
                  [
                    _vm.convertVipPower(
                      _vm.powersMap.code_max_files.vip_1.show_value,
                      _vm.powersMap.code_max_files.vip_1.value
                    ) === ""
                      ? [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/ic_allow.png"),
                              alt: ""
                            }
                          })
                        ]
                      : [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.convertVipPower(
                                  _vm.powersMap.code_max_files.vip_0.show_value,
                                  _vm.powersMap.code_max_files.vip_0.value
                                )
                              ) +
                              "\n            "
                          )
                        ]
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "contrast-item contrast-item-true" }, [
                _c("div", { staticClass: "contrast-item-name" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.powersMap.max_task_download.name) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contrast-item-vip contrast-item-vip-true" },
                  [
                    _vm.convertVipPower(
                      _vm.powersMap.max_task_download.vip_1.show_value,
                      _vm.powersMap.max_task_download.vip_1.value
                    ) === ""
                      ? [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/ic_allow.png"),
                              alt: ""
                            }
                          })
                        ]
                      : [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.convertVipPower(
                                  _vm.powersMap.max_task_download.vip_0
                                    .show_value,
                                  _vm.powersMap.max_task_download.vip_0.value
                                )
                              ) +
                              "\n            "
                          )
                        ]
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contrast-item-contrast" },
                  [
                    _vm.convertVipPower(
                      _vm.powersMap.max_task_download.vip_1.show_value,
                      _vm.powersMap.max_task_download.vip_1.value
                    ) === ""
                      ? [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/ic_allow.png"),
                              alt: ""
                            }
                          })
                        ]
                      : [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.convertVipPower(
                                  _vm.powersMap.max_task_download.vip_0
                                    .show_value,
                                  _vm.powersMap.max_task_download.vip_0.value
                                )
                              ) +
                              "\n            "
                          )
                        ]
                  ],
                  2
                )
              ])
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "products-buy-body" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "btn-body" }, [
        _c("div", { staticClass: "btn" }, [
          _vm._v("\n        同意协议并支付 "),
          _c("span", [_vm._v("¥")]),
          _c("label", [
            _vm._v(
              _vm._s(
                _vm.productsArr.length <= 0
                  ? "0"
                  : _vm.productsArr[_vm.selectedProductIndex].sell_price
              )
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contrast-title" }, [
      _c("div", { staticClass: "name" }, [
        _vm._v("\n            权益\n          ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "icon" }, [
        _c("img", { attrs: { src: require("@/assets/ic_vip.png"), alt: "" } })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contrast" }, [
        _vm._v("\n            普通用户\n          ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "agreement-body" }, [
      _c("div", { staticClass: "check-box" }, [
        _c("img", {
          attrs: { src: require("@/assets/check_square_y.png"), alt: "" }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "agreement" }, [
        _vm._v("\n        请阅读并同意 "),
        _c("a", { attrs: { href: "" } }, [_vm._v("续费协议")]),
        _c("label", [_vm._v("｜")]),
        _c("a", { attrs: { href: "" } }, [_vm._v("用户协议")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-af266d56", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af266d56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/tab_member.vue
// module id = null
// module chunks = 